import { Badge, type BadgeTone } from './Badge.js';

export type CompatibilityStatus = 'passed' | 'failed' | 'stale' | 'untested';

const toneMap: Record<CompatibilityStatus, BadgeTone> = {
  passed: 'success',
  failed: 'error',
  stale: 'warning',
  untested: 'neutral',
};

const labelMap: Record<CompatibilityStatus, string> = {
  passed: 'Tested compatible',
  failed: 'Failed test',
  stale: 'Stale evidence',
  untested: 'Unknown',
};

export interface CompatibilityBadgeProps {
  status?: CompatibilityStatus;
  destination?: string | null;
  href?: string | null;
}

export function CompatibilityBadge({
  status = 'untested',
  destination,
  href,
}: CompatibilityBadgeProps) {
  const label = destination ? `${labelMap[status]} · ${destination}` : labelMap[status];
  const badge = <Badge tone={toneMap[status]}>{label}</Badge>;
  if (href) {
    return (
      <a href={href} style={{ textDecoration: 'none' }}>
        {badge}
      </a>
    );
  }
  return badge;
}
